export const START_LOAD_PREREQUESTS = 'START_LOAD_PREREQUESTS';
export const ERROR_LOAD_PREREQUESTS = 'ERROR_LOAD_PREREQUESTS';
export const FINISH_LOAD_PREREQUESTS = 'FINISH_LOAD_PREREQUESTS';

export const START_SEND_PREREQUESTS = 'START_SEND_PREREQUESTS';
export const ERROR_SEND_PREREQUESTS = 'ERROR_SEND_PREREQUESTS';
export const FINISH_SEND_PREREQUESTS = 'FINISH_SEND_PREREQUESTS';